import WhatsAppPanel from './WhatsAppPanel';
import FeriadosPanel from './FeriadosPanel';
import HorariosPanel from './HorariosPanel';
import AnalyticsPanel from './AnalyticsPanel';
import VisionPanel from './VisionPanel';
import React, { useEffect, useState } from 'react';
import './App.css';
import {
  ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid,
  Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell
} from 'recharts';

const API = '';
const STORES = [
  { id: 6, name: 'Niko 1' },
  { id: 3, name: 'Niko 2' },
  { id: 1, name: 'Niko 3' },
  { id: 2, name: 'Niko 4' },
  { id: 4, name: 'Niko 5' },
  { id: 5, name: 'Niko 7' },
  // Niko 7 Ingreso (id:8) - camara secundaria de Niko 7, sin tab propio
];
const TODAY = (() => {
  const d = new Date();
  d.setHours(d.getHours() - 3);
  return d.toISOString().split('T')[0];
})();

function PctBadge({ val }: { val: number | null }) {
  if (val === null || val === undefined) return <span className="badge-neutral">—</span>;
  const up = val >= 0;
  return <span className={up ? 'badge-up' : 'badge-down'}>{up ? '↑' : '↓'}{Math.abs(val)}%</span>;
}
function fmtMoney(n: number) {
  if (n >= 1000000) return `$${(n / 1000000).toFixed(1)}M`;
  if (n >= 1000) return `$${(n / 1000).toFixed(1)}k`;
  return `$${n.toLocaleString('es-AR')}`;
}
function fmtTicket(n: number) {
  return `$ ${n.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

function KpiCard({ title, main, ayerVal, ayerPct, semVal, semPct }:
  { title: string; main: string; ayerVal: string; ayerPct: number | null; semVal: string; semPct: number | null }) {
  return (
    <div className="kpi-sales-card">
      <div className="kpi-sales-title">{title}</div>
      <div className="kpi-sales-main">{main}</div>
      <div className="kpi-sales-label">Hoy</div>
      <div className="kpi-sales-row"><PctBadge val={ayerPct} /><span className="kpi-ref">{ayerVal} Ayer</span></div>
      <div className="kpi-sales-row"><PctBadge val={semPct} /><span className="kpi-ref">{semVal} Sem. Pasada</span></div>
    </div>
  );
}

function MercadoCard({ msg, color, benchmark, conversion, storeId, onBenchmarkSave }: {
  msg: string; color: string; benchmark: number; conversion: number;
  storeId: number; onBenchmarkSave: (v: number) => void;
}) {
  const [editing, setEditing] = React.useState(false);
  const [editVal, setEditVal] = React.useState(String(benchmark));
  const pct = benchmark > 0 ? Math.min(100, Math.round((conversion / benchmark) * 100)) : 0;
  const barColor = conversion >= benchmark ? '#4ade80' : conversion >= benchmark * 0.7 ? '#f59e0b' : '#ef4444';
  const save = async () => {
    const v = parseFloat(editVal);
    if (isNaN(v) || v <= 0) return;
    await fetch('/api/benchmark/' + storeId, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ benchmark: v }) });
    onBenchmarkSave(v);
    setEditing(false);
  };
  return (
    <div className="kpi-sales-card">
      <div className="kpi-sales-title" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        Comparacion con el Mercado
        <button
          onClick={() => { setEditVal(String(benchmark)); setEditing(!editing); }}
          style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', fontSize: 11, color: '#64748b' }}
        >[edit]</button>
      </div>
      {editing && (
        <div style={{ display: 'flex', gap: 6, marginTop: 8, alignItems: 'center' }}>
          <input type="number" value={editVal} onChange={e => setEditVal(e.target.value)}
            style={{ width: 60, padding: '2px 6px', borderRadius: 6, border: '1px solid #334155', background: '#1e293b', color: '#f1f5f9', fontSize: 13 }} />
          <span style={{ fontSize: 11, color: '#94a3b8' }}>%</span>
          <button onClick={save} style={{ background: '#3b82f6', color: '#fff', border: 'none', borderRadius: 6, padding: '2px 10px', fontSize: 12, cursor: 'pointer' }}>Guardar</button>
          <button onClick={() => setEditing(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#64748b', fontSize: 12 }}>X</button>
        </div>
      )}
      <div style={{ marginTop: 10 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 4 }}>
          <span style={{ fontSize: 11, color: '#94a3b8' }}>Tu conversion</span>
          <span style={{ fontSize: 16, fontWeight: 700, color: barColor }}>{conversion}%</span>
        </div>
        <div style={{ background: '#1e293b', borderRadius: 8, height: 10, overflow: 'hidden', marginBottom: 6 }}>
          <div style={{ width: pct + '%', height: '100%', background: barColor, borderRadius: 8, transition: 'width 0.6s ease' }} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 10, color: '#64748b', marginBottom: 8 }}>
          <span>0%</span>
          <span style={{ color: '#94a3b8' }}>Ref: {benchmark}%</span>
          <span>{Math.round(benchmark * 2)}%+</span>
        </div>
        <div style={{ fontSize: 12, color: color === 'green' ? '#4ade80' : '#f59e0b', fontWeight: 600, textAlign: 'center' }}>
          {msg}
        </div>
      </div>
    </div>
  );
}

function VeredaWidget({ storeId, localTotal }: { storeId: number; localTotal: number }) {
  const token = localStorage.getItem('pc_token') || '';
  const veredaId = storeId === 1 ? 22 : 23;
  const [veredaSummary, setVeredaSummary] = React.useState<any>(null);
  React.useEffect(() => {
    fetch(`/api/counts/summary?store_id=${veredaId}&date=${TODAY}`, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(r => r.json()).then(setVeredaSummary).catch(() => {});
  }, [veredaId]);
  const veredaTotal = veredaSummary?.total_in || 0;
  const pct = veredaTotal > 0 ? ((localTotal / veredaTotal) * 100).toFixed(1) : null;
  return (
    <div style={{background:'#1e293b', borderRadius:12, padding:20, marginTop:16}}>
      <div style={{fontSize:13, fontWeight:700, color:'#94a3b8', marginBottom:12, textTransform:'uppercase', letterSpacing:1}}>
        🚶 Tráfico Vereda vs Local
      </div>
      <div style={{display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:12}}>
        <div style={{background:'#0f172a', borderRadius:8, padding:12, textAlign:'center'}}>
          <div style={{fontSize:11, color:'#64748b', marginBottom:4}}>VEREDA HOY</div>
          <div style={{fontSize:24, fontWeight:700, color:'#e2e8f0'}}>{veredaTotal}</div>
        </div>
        <div style={{background:'#0f172a', borderRadius:8, padding:12, textAlign:'center'}}>
          <div style={{fontSize:11, color:'#64748b', marginBottom:4}}>INGRESAN</div>
          <div style={{fontSize:24, fontWeight:700, color:'#e2e8f0'}}>{localTotal}</div>
        </div>
        <div style={{background: pct ? '#0f4c2a' : '#0f172a', borderRadius:8, padding:12, textAlign:'center'}}>
          <div style={{fontSize:11, color:'#64748b', marginBottom:4}}>CONVERSIÓN REAL</div>
          <div style={{fontSize:24, fontWeight:700, color: pct ? '#4ade80' : '#64748b'}}>
            {pct ? `${pct}%` : '—'}
          </div>
        </div>
      </div>
      {pct && (
        <div style={{marginTop:10, fontSize:12, color:'#64748b', textAlign:'center'}}>
          De cada 100 que pasan por la vereda, {Math.round(parseFloat(pct))} entran al local
        </div>
      )}
    </div>
  );
}

// ============================================================
// IA COMERCIAL WIDGET
// ============================================================
function IAComercialWidget({ storeId, storeName, dashDate, summary, benchmark }: {
  storeId: number; storeName: string; dashDate: string;
  summary: any; benchmark: number;
}) {
  const [analysis, setAnalysis] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);
  const [expanded, setExpanded] = React.useState(false);
  const lastFetch = React.useRef<string>('');

  const fetchAnalysis = async () => {
    if (!summary) return;
    const key = `${storeId}-${dashDate}`;
    if (lastFetch.current === key && analysis) return;
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem('token');
      const body = {
        store_name: storeName,
        store_id: storeId,
        fecha: dashDate,
        flujo: {
          hoy: summary.total_in || 0,
          ayer: summary.yesterday_in || 0,
          pct_ayer: summary.yesterday_in
            ? Math.round(((summary.total_in - summary.yesterday_in) / summary.yesterday_in) * 1000) / 10
            : 0
        },
        ventas: {
          hoy: summary.ventas || 0,
          ayer: summary.ventas_ayer || 0,
          pct_ayer: summary.ventas_ayer
            ? Math.round(((summary.ventas - summary.ventas_ayer) / summary.ventas_ayer) * 1000) / 10
            : 0
        },
        conversion: {
          hoy: summary.conversion || 0,
          ayer: summary.conversion_ayer || 0
        },
        ticket: { hoy: summary.ticket || 0 },
        ingresos: { hoy: summary.ingresos || 0 },
        benchmark: benchmark,
        hourly: summary.hourly || []
      };
      const resp = await fetch('/api/ai/analyze', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify(body)
      });
      if (!resp.ok) throw new Error('Error ' + resp.status);
      const data = await resp.json();
      setAnalysis(data.analysis);
      lastFetch.current = key;
      setExpanded(true);
    } catch (e: any) {
      setError('No se pudo generar el análisis');
    } finally {
      setLoading(false);
    }
  };

  const renderAnalysis = (text: string) => {
    const sections = text.split('\n\n');
    return sections.map((section, idx) => {
      if (section.startsWith('RESUMEN')) {
        return (
          <div key={idx} style={{marginBottom:'12px'}}>
            <div style={{fontWeight:700,color:'#60a5fa',fontSize:'11px',letterSpacing:'1px',marginBottom:'4px'}}>📊 RESUMEN</div>
            <div style={{color:'#e2e8f0',fontSize:'13px',lineHeight:1.6}}>{section.replace('RESUMEN\n','')}</div>
          </div>
        );
      }
      if (section.startsWith('OBSERVACIONES')) {
        const lines = section.replace('OBSERVACIONES\n','').split('\n').filter(Boolean);
        return (
          <div key={idx} style={{marginBottom:'12px'}}>
            <div style={{fontWeight:700,color:'#fbbf24',fontSize:'11px',letterSpacing:'1px',marginBottom:'4px'}}>⚠️ OBSERVACIONES</div>
            {lines.map((line, li) => (
              <div key={li} style={{color:'#cbd5e1',fontSize:'12px',lineHeight:1.6,paddingLeft:'8px',borderLeft:'2px solid #fbbf2440',marginBottom:'4px'}}>
                {line}
              </div>
            ))}
          </div>
        );
      }
      if (section.startsWith('RECOMENDACIÓN') || section.startsWith('RECOMENDACION')) {
        return (
          <div key={idx} style={{marginBottom:'4px'}}>
            <div style={{fontWeight:700,color:'#34d399',fontSize:'11px',letterSpacing:'1px',marginBottom:'4px'}}>👉 RECOMENDACIÓN</div>
            <div style={{color:'#a7f3d0',fontSize:'12px',lineHeight:1.6,background:'rgba(52,211,153,0.08)',padding:'8px',borderRadius:'6px'}}>
              {section.replace(/RECOMENDACI[OÓ]N\n/,'')}
            </div>
          </div>
        );
      }
      return section ? <div key={idx} style={{color:'#94a3b8',fontSize:'12px',marginBottom:'8px'}}>{section}</div> : null;
    });
  };

  return (
    <div className="chart-card" style={{background:'linear-gradient(135deg,#0f172a,#1e293b)',border:'1px solid #334155'}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'12px'}}>
        <h3 style={{margin:0,display:'flex',alignItems:'center',gap:'8px',color:'#e2e8f0'}}>
          <span style={{fontSize:'20px'}}>🤖</span>
          <span>IA Comercial</span>
          <span style={{fontSize:'11px',color:'#64748b',fontWeight:400}}>claude haiku</span>
        </h3>
        <button
          onClick={fetchAnalysis}
          disabled={loading}
          style={{
            background: loading ? '#334155' : 'linear-gradient(135deg,#3b82f6,#8b5cf6)',
            color:'white', border:'none', borderRadius:'8px',
            padding:'6px 14px', fontSize:'12px', cursor: loading ? 'default' : 'pointer',
            fontWeight:600, display:'flex', alignItems:'center', gap:'6px'
          }}
        >
          {loading ? '⏳ Analizando...' : analysis ? '🔄 Actualizar' : '✨ Analizar'}
        </button>
      </div>

      {!analysis && !loading && (
        <div style={{textAlign:'center',padding:'24px',color:'#475569',fontSize:'13px'}}>
          <div style={{fontSize:'32px',marginBottom:'8px'}}>🤖</div>
          <div>Presioná <strong style={{color:'#60a5fa'}}>Analizar</strong> para obtener un informe de IA sobre el día de hoy</div>
        </div>
      )}

      {loading && (
        <div style={{textAlign:'center',padding:'24px',color:'#60a5fa',fontSize:'13px'}}>
          <div style={{fontSize:'32px',marginBottom:'8px',animation:'spin 1s linear infinite'}}>⏳</div>
          <div>Analizando datos con Claude Haiku...</div>
        </div>
      )}

      {error && (
        <div style={{color:'#f87171',fontSize:'12px',padding:'12px',background:'rgba(248,113,113,0.1)',borderRadius:'6px'}}>
          {error}
        </div>
      )}

      {analysis && !loading && (
        <div>
          <div onClick={() => setExpanded(!expanded)} style={{cursor:'pointer',marginBottom:'8px',color:'#64748b',fontSize:'11px',textAlign:'right'}}>
            {expanded ? '▲ Contraer' : '▼ Expandir'}
          </div>
          {expanded && (
            <div style={{borderTop:'1px solid #1e293b',paddingTop:'12px'}}>
              {renderAnalysis(analysis)}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function StorePanel({ storeId, storeName, dashDate }: { storeId: number; storeName: string; dashDate: string }) {
  const [summary, setSummary] = useState<any>(null);
  const [sales, setSales]     = useState<any>(null);
  const [chart, setChart]     = useState<any[]>([]);
  const [hourly, setHourly]   = useState<any[]>([]);
  const [weekly, setWeekly]   = useState<any[]>([]);
  const [hourlyAvg, setHourlyAvg] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [heatmapData, setHeatmapData] = useState<any[]>([]);
  const [allStores, setAllStores] = useState<any[]>([]);
  const [calDate, setCalDate] = useState(() => new Date());
  const [hourlyMode, setHourlyMode] = useState<'today' | 'week'>('today');
  const [benchmarkVal, setBenchmarkVal] = React.useState<number>(25);

  useEffect(() => {
    setLoading(true);
    const today = dashDate;
    Promise.all([
      fetch(`${API}/api/counts/summary?store_id=${storeId}&date=${today}`).then(r => r.json()).catch(() => null),
      fetch(`${API}/api/sales/daily?store_id=${storeId}&date=${today}`).then(r => r.json()).catch(() => null),
      fetch(`${API}/api/sales/chart?store_id=${storeId}&date=${today}`).then(r => r.json()).catch(() => []),
      fetch(`${API}/api/counts/hourly?store_id=${storeId}&date=${today}`).then(r => r.json()).catch(() => []),
      fetch(`${API}/api/counts/weekly?store_id=${storeId}`).then(r => r.json()).catch(() => []),
      fetch(`${API}/api/analytics/hourly?store_id=${storeId}&dias=30`).then(r => r.json()).catch(() => []),
      fetch(`${API}/api/analytics/heatmap?store_id=${storeId}`).then(r => r.json()).catch(() => []),
    ]).then(([sum, sal, ch, hr, wk, havg, hmap]) => {
      setSummary(sum); setSales(sal); setChart(Array.isArray(ch) ? ch : []);
      setHourly(Array.isArray(hr) ? hr : []); setWeekly(Array.isArray(wk) ? wk : []);
      setHourlyAvg(Array.isArray(havg) ? havg : []);
      setHeatmapData(Array.isArray(hmap) ? hmap : []);
      setLoading(false);
    });
fetch(`${API}/api/benchmark`).then(r => r.json()).then((d: any) => {
  const v = d[String(storeId)];
  if (v != null) setBenchmarkVal(Number(v));
}).catch(() => {});
    Promise.all(STORES.map((s: any) =>
      fetch(`${API}/api/counts/summary?store_id=${s.id}&date=${TODAY}`)
        .then(r => r.json()).catch(() => ({ store_name: s.name, total_in: 0 }))
    )).then(setAllStores);
  }, [dashDate, storeId]);

  if (loading) return <div className="loading">Cargando datos...</div>;

  const totalIn  = summary?.total_in ?? 0;
  const totalOut = summary?.total_out ?? 0;
  const inside   = summary?.current_inside ?? 0;
  const hasSales = sales && !sales.error;

  return (
    <div className="store-panel">
      <IAComercialWidget storeId={storeId} storeName={storeName} dashDate={dashDate} summary={summary} benchmark={benchmarkVal} />
      {/* Fila KPI conteo */}
      <div className="count-kpi-row">
        <div className="count-kpi-box"><span className="count-label">Entradas</span><span className="count-num">{totalIn}</span></div>
        <div className="count-kpi-box"><span className="count-label">Salidas</span><span className="count-num">{totalOut}</span></div>
        <div className="count-kpi-box"><span className="count-label">Dentro ahora</span><span className="count-num">{inside}</span></div>
      </div>

      {/* KPI Ventas */}
      {hasSales ? (
        <div className="kpi-sales-grid">
          <KpiCard title="Flujo" main={String(sales.flujo?.hoy ?? 0)}
            ayerVal={String(sales.flujo?.ayer ?? 0)} ayerPct={sales.flujo?.pct_ayer}
            semVal={String(sales.flujo?.sem_pasada ?? 0)} semPct={sales.flujo?.pct_sem} />
          <KpiCard title="Ventas" main={String(sales.ventas?.hoy ?? 0)}
            ayerVal={String(sales.ventas?.ayer ?? 0)} ayerPct={sales.ventas?.pct_ayer}
            semVal={String(sales.ventas?.sem_pasada ?? 0)} semPct={sales.ventas?.pct_sem} />
          <KpiCard title="Ticket Promedio" main={fmtTicket(sales.ticket?.hoy ?? 0)}
            ayerVal={fmtTicket(sales.ticket?.ayer ?? 0)} ayerPct={sales.ticket?.pct_ayer}
            semVal={fmtTicket(sales.ticket?.sem_pasada ?? 0)} semPct={sales.ticket?.pct_sem} />
          <KpiCard title="Ingresos" main={fmtMoney(sales.ingresos?.hoy ?? 0)}
            ayerVal={fmtMoney(sales.ingresos?.ayer ?? 0)} ayerPct={sales.ingresos?.pct_ayer}
            semVal={fmtMoney(sales.ingresos?.sem_pasada ?? 0)} semPct={sales.ingresos?.pct_sem} />
          <KpiCard title="Tasa de Conversión" main={`${sales.conversion?.hoy ?? 0}%`}
            ayerVal={`${sales.conversion?.ayer ?? 0}%`} ayerPct={sales.conversion?.pct_ayer}
            semVal={`${sales.conversion?.sem_pasada ?? 0}%`} semPct={sales.conversion?.pct_sem} />
          <MercadoCard msg={sales.mercado?.mensaje ?? ''} color={sales.mercado?.color ?? 'orange'} benchmark={benchmarkVal} conversion={sales.conversion?.hoy ?? 0} storeId={storeId} onBenchmarkSave={(v: number) => setBenchmarkVal(v)} />
        </div>
      ) : (
        <div className="no-sales">Sin datos de ventas disponibles</div>
      )}

      {/* Grafico Flujo x Ventas */}
      {chart.length > 0 && (
        <div className="chart-card">
          <h3>Flujo × Ventas</h3>
          <ResponsiveContainer width="100%" height={280}>
            <ComposedChart data={chart} margin={{ top: 10, right: 50, left: 0, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#334155" />
              <XAxis dataKey="fecha" tick={{ fill: '#94a3b8', fontSize: 11 }} tickFormatter={v => v.slice(5)} />
              <YAxis yAxisId="left" tick={{ fill: '#94a3b8', fontSize: 11 }} />
              <YAxis yAxisId="right" orientation="right" unit="%" tick={{ fill: '#f59e0b', fontSize: 11 }} />
              <Tooltip contentStyle={{ background: '#1e293b', border: '1px solid #334155', color: '#f1f5f9' }}
                formatter={(val: any, name: any) => name === 'Conversión' ? [`${val}%`, name] : [val, name]} />
              <Legend wrapperStyle={{ color: '#94a3b8', fontSize: 12 }} />
              <Bar yAxisId="left" dataKey="flujo" name="Flujo" fill="#3b82f6" fillOpacity={0.7} radius={[3,3,0,0]} />
              <Bar yAxisId="left" dataKey="ventas" name="Ventas" fill="#818cf8" fillOpacity={0.9} radius={[3,3,0,0]} />
              <Line yAxisId="right" type="monotone" dataKey="conversion" name="Conversión"
                stroke="#f59e0b" strokeWidth={2.5} dot={{ fill: '#f59e0b', r: 4 }} />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      )}

      {/* Tablas */}
      <div className="tables-row">
        <div className="chart-card">
          <h3>Visitantes por Hora</h3>
          {(() => {
            const hours = Array.from({length: 17}, (_: any, i: number) => i + 6);
            const todayMap: Record<number, number> = {};
            hourly.forEach((d: any) => { todayMap[parseInt(d.hour)] = d.entrances; });
            const avgMap: Record<number, number> = {};
            hourlyAvg.forEach((d: any) => { avgMap[d.hora] = Math.round(d.promedio * 10) / 10; });
            const chartData = hours.map((h: number) => ({
              hour: h + 'h',
              hoy: todayMap[h] || 0,
              media: avgMap[h] || 0,
            }));
            return (
              <ResponsiveContainer width="100%" height={220}>
                <ComposedChart data={chartData} margin={{ top: 5, right: 10, left: -10, bottom: 5 }}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                  <XAxis dataKey="hour" tick={{ fontSize: 10 }} />
                  <YAxis tick={{ fontSize: 10 }} />
                  <Tooltip formatter={(val: any, name: any) =>
                    name === 'media' ? [`${val}`, 'Media (30d)'] : [`${val}`, 'Hoy']} />
                  <Legend formatter={(val: any) => val === 'media' ? 'Media (últimos 30d)' : 'Hoy'}
                    iconSize={10} wrapperStyle={{ fontSize: 11 }} />
                  <Bar dataKey="hoy" name="hoy" fill="#3b82f6" fillOpacity={0.85} radius={[2,2,0,0] as any} />
                  <Line dataKey="media" name="media" type="monotone" stroke="#f97316"
                    strokeWidth={2.5} dot={{ r: 3, fill: '#f97316' }} activeDot={{ r: 5 }} />
                </ComposedChart>
              </ResponsiveContainer>
            );
          })()}
        </div>
        <div className="chart-card">
          <h3>Tráfico Semanal</h3>
          <table><thead><tr><th>Fecha</th><th>Entradas</th><th>Salidas</th></tr></thead>
            <tbody>{weekly.length === 0
              ? <tr><td colSpan={3} className="no-data">Sin datos</td></tr>
              : weekly.map((r:any) => <tr key={r.date}><td>{r.date}</td><td>{r.total_in}</td><td>{r.total_out}</td></tr>)}
            </tbody>
          </table>
        </div>

        <div className="chart-card" style={{gridColumn: '1 / -1'}}>
          <h3>Visitantes por Día</h3>
          {weekly.length > 0 && (() => {
            const DAYS: string[] = ['Dom','Lun','Mar','Mié','Jue','Vie','Sáb'];
            const dayMap: {[key: string]: number} = {};
            weekly.forEach((d: any) => { dayMap[String(d.date)] = Number(d.total_in); });
            const dates: string[] = weekly.map((d: any) => String(d.date)).sort();
            const firstDate = new Date(dates[0]);
            const lastDate = new Date(dates[dates.length - 1]);
            const maxVal = Math.max(...weekly.map((d: any) => Number(d.total_in)));
            const gc = (v: number): string => !v ? '#ebedf0' : v / maxVal < 0.2 ? '#c6e4f7' : v / maxVal < 0.4 ? '#7ec8e3' : v / maxVal < 0.6 ? '#1a9fd4' : v / maxVal < 0.8 ? '#1167b1' : '#03254c';
            const sdow: number = firstDate.getDay();
            const total: number = Math.round((lastDate.getTime() - firstDate.getTime()) / 86400000) + 1;
            const nw: number = Math.ceil((sdow + total) / 7);
            const cols: Array<Array<{v: number|null, ds: string|null}>> = [];
            for (let wi = 0; wi < nw; wi++) {
              const week: Array<{v: number|null, ds: string|null}> = [];
              for (let di = 0; di < 7; di++) {
                const off = wi * 7 + di - sdow;
                const ds: string|null = (off >= 0 && off < total) ? new Date(firstDate.getTime() + off * 86400000).toISOString().slice(0, 10) : null;
                week.push({ v: ds !== null ? (dayMap[ds] ?? 0) : null, ds });
              }
              cols.push(week);
            }
            return (
              <div style={{overflowX: 'auto'}}>
                <div style={{display: 'flex', gap: '2px'}}>
                  <div style={{display: 'flex', flexDirection: 'column', gap: '2px', marginRight: '4px'}}>
                    {DAYS.map((day: string) => <span key={day} style={{fontSize: '10px', color: '#666', lineHeight: '13px', height: '13px', display: 'flex', alignItems: 'center'}}>{day}</span>)}
                  </div>
                  {cols.map((week: Array<{v: number|null, ds: string|null}>, wi: number) => (
                    <div key={wi} style={{display: 'flex', flexDirection: 'column', gap: '2px'}}>
                      {week.map((cell: {v: number|null, ds: string|null}, di: number) => (
                        <div key={di} title={cell.ds !== null ? cell.ds + ': ' + cell.v : ''}
                          style={{width: '13px', height: '13px', borderRadius: '2px', background: cell.v !== null ? gc(cell.v) : 'transparent'}} />
                      ))}
                    </div>
                  ))}
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '4px', marginTop: '8px', fontSize: '10px', color: '#666'}}>
                  <span>Menos</span>
                  {(['#ebedf0','#c6e4f7','#7ec8e3','#1a9fd4','#1167b1','#03254c'] as string[]).map((c: string) => (
                    <div key={c} style={{width: '13px', height: '13px', borderRadius: '2px', background: c}} />
                  ))}
                  <span>Más</span>
                </div>
              </div>
            );
          })()}
        </div>

        {/* ===== NUEVOS WIDGETS ===== */}

        {/* Widget: Visitantes por Hora MEJORADO con toggle Hoy/Semana */}
        <div className="chart-card" style={{gridColumn: '1 / -1'}}>
          <div style={{display:'flex',alignItems:'center',marginBottom:'8px'}}>
            <h3 style={{margin:0}}>📊 Visitantes por Hora</h3>
            <div style={{marginLeft:'auto',display:'flex',gap:'4px'}}>
              {(['today','week'] as const).map(m => (
                <button key={m} onClick={() => setHourlyMode(m)}
                  style={{padding:'3px 10px',borderRadius:'6px',border:'1px solid #e2e8f0',
                    background: hourlyMode===m ? '#1a1a2e' : '#f8fafc',
                    color: hourlyMode===m ? '#fff' : '#64748b',
                    fontSize:'11px',cursor:'pointer'}}>
                  {m==='today' ? 'Hoy' : 'Semana'}
                </button>
              ))}
            </div>
          </div>
          {(() => {
            const hours = Array.from({length:17},(_,i)=>i+6);
            const todayMap: {[k:number]:number} = {};
            hourly.forEach((d:any) => { todayMap[parseInt(d.hour)] = d.entrances; });
            const avgMap: {[k:number]:number} = {};
            hourlyAvg.forEach((d:any) => { avgMap[d.hora] = d.promedio; });
            const weekMap: {[k:number]:number} = {};
            hourlyAvg.forEach((d:any) => { weekMap[d.hora] = d.total; });
            const chartData = hours.map(h => ({
              hour: h + 'h',
              hoy: hourlyMode==='today' ? (todayMap[h]||0) : (weekMap[h]||0),
              media: avgMap[h]||0,
            }));
            return (
              <ResponsiveContainer width="100%" height={220}>
                <ComposedChart data={chartData} margin={{top:5,right:10,left:-10,bottom:5}}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                  <XAxis dataKey="hour" tick={{fontSize:10}} />
                  <YAxis tick={{fontSize:10}} />
                  <Tooltip formatter={(val:any,name:any) =>
                    name==='media' ? [`${val}`,'Media (30d)'] : [`${val}`,hourlyMode==='today'?'Hoy':'Semana']} />
                  <Legend formatter={(val:any) => val==='media' ? 'Media (últimos 30d)' : (hourlyMode==='today'?'Hoy':'Esta semana')}
                    iconSize={10} wrapperStyle={{fontSize:11}} />
                  <Bar dataKey="hoy" name="hoy" fill="#1a1a2e" fillOpacity={0.8} radius={[2,2,0,0] as any} />
                  <Line dataKey="media" name="media" type="monotone" stroke="#f97316"
                    strokeWidth={2.5} dot={{r:3,fill:'#f97316'}} activeDot={{r:5}} />
                </ComposedChart>
              </ResponsiveContainer>
            );
          })()}
        </div>

        {/* Widget: Donut Visitantes por Establecimiento */}
        {allStores.filter((s:any)=>s.total_in>0).length > 0 && (
          <div className="chart-card">
            <h3>🍩 Visitantes por Establecimiento — Hoy</h3>
            {(() => {
              const withData = allStores.filter((s:any) => s.total_in > 0);
              const total = withData.reduce((a:number,b:any) => a+b.total_in, 0);
              const COLORS = ['#1a1a2e','#3b82f6','#10b981','#f97316','#8b5cf6','#ef4444','#06b6d4'];
              const data = withData.map((s:any,i:number) => ({
                name: s.store_name, value: s.total_in, color: COLORS[i%COLORS.length]
              }));
              return (
                <div style={{display:'flex',alignItems:'center',gap:'20px',flexWrap:'wrap'}}>
                  <ResponsiveContainer width={200} height={200}>
                    <PieChart>
                      <Pie data={data} dataKey="value" nameKey="name"
                        cx="50%" cy="50%" innerRadius={55} outerRadius={90}
                        paddingAngle={2}>
                        {data.map((entry:any,i:number) => (
                          <Cell key={i} fill={entry.color} />
                        ))}
                      </Pie>
                      <Tooltip formatter={(v:any) => [`${v} visitantes`,'']} />
                    </PieChart>
                  </ResponsiveContainer>
                  <div style={{flex:1,minWidth:120}}>
                    {data.map((s:any,i:number) => (
                      <div key={i} style={{display:'flex',alignItems:'center',gap:'8px',marginBottom:'8px'}}>
                        <span style={{width:'12px',height:'12px',borderRadius:'3px',background:s.color,flexShrink:0,display:'inline-block'}}/>
                        <span style={{color:'#475569',fontSize:'13px'}}>{s.name}</span>
                        <span style={{marginLeft:'auto',fontWeight:700,color:'#1a1a2e'}}>{s.value}</span>
                        <span style={{color:'#94a3b8',fontSize:'11px'}}>({Math.round(s.value/total*100)}%)</span>
                      </div>
                    ))}
                    <div style={{marginTop:'8px',paddingTop:'8px',borderTop:'1px solid #f1f5f9',fontWeight:700}}>Total: {total}</div>
                  </div>
                </div>
              );
            })()}
          </div>
        )}

        {/* Widget: Visitantes x Ventas con línea de conversión */}
        {chart.length > 0 && (
          <div className="chart-card" style={{gridColumn:'1 / -1'}}>
            <h3>📈 Visitantes × Ventas — Últimos 7 días</h3>
            <ResponsiveContainer width="100%" height={220}>
              <ComposedChart data={chart} margin={{top:5,right:30,left:-10,bottom:5}}>
                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                <XAxis dataKey="fecha" tickFormatter={(v:string)=>v.substring(5)} tick={{fontSize:10}} />
                <YAxis yAxisId="left" tick={{fontSize:10}} label={{value:'Visitantes/Ventas',angle:-90,position:'insideLeft',fontSize:10,offset:15}} />
                <YAxis yAxisId="right" orientation="right" tick={{fontSize:10}}
                  tickFormatter={(v:number)=>v+'%'} domain={[0,50]}
                  label={{value:'Conversión (%)',angle:90,position:'insideRight',fontSize:10,offset:10}} />
                <Tooltip contentStyle={{fontSize:'12px'}}
                  formatter={(val:any,name:any) => name==='conversion' ? [val+'%','Conversión'] : [val,name==='flujo'?'Visitantes':'Ventas']} />
                <Legend wrapperStyle={{fontSize:11}} iconSize={10}
                  formatter={(v:any)=>v==='flujo'?'Visitantes':v==='ventas'?'Ventas':'Tasa Conversión'} />
                <Bar yAxisId="left" dataKey="flujo" name="flujo" fill="#1a1a2e" fillOpacity={0.8} radius={[2,2,0,0] as any} />
                <Bar yAxisId="left" dataKey="ventas" name="ventas" fill="#3b82f6" fillOpacity={0.8} radius={[2,2,0,0] as any} />
                <Line yAxisId="right" type="monotone" dataKey="conversion" name="conversion"
                  stroke="#f97316" strokeWidth={2.5} dot={{r:4,fill:'#f97316'}} activeDot={{r:6}} />
              </ComposedChart>
            </ResponsiveContainer>
          </div>
        )}

        {/* Widget: Heatmap Hora x Día de Semana */}
        {heatmapData.length > 0 && (
          <div className="chart-card" style={{gridColumn:'1 / -1'}}>
            <h3>🔥 Mapa de Calor — Visitantes por Hora y Día de Semana</h3>
            {(() => {
              const DAY_NAMES = ['Lun','Mar','Mié','Jue','Vie','Sáb','Dom'];
              const displayHours = Array.from({length:17},(_:any,i:number)=>i+6);
              const matrix: {[dia:number]:{[hora:number]:number}} = {};
              heatmapData.forEach((d:any) => {
                if (!matrix[d.dia]) matrix[d.dia] = {};
                matrix[d.dia][d.hora] = d.total;
              });
              const maxVal = Math.max(...heatmapData.map((d:any)=>d.total), 1);
              const gc = (v:number) => {
                const i = v/maxVal;
                return `rgba(30,64,175,${Math.max(0.08,i).toFixed(2)})`;
              };
              return (
                <div style={{overflowX:'auto'}}>
                  <div style={{display:'grid',gridTemplateColumns:'36px repeat(17,1fr)',gap:'2px',marginBottom:'4px'}}>
                    <div/>
                    {displayHours.map(h=>(
                      <div key={h} style={{textAlign:'center',fontSize:'9px',color:'#94a3b8'}}>{h}h</div>
                    ))}
                  </div>
                  {[1,2,3,4,5,6,7].map(dia=>(
                    <div key={dia} style={{display:'grid',gridTemplateColumns:'36px repeat(17,1fr)',gap:'2px',marginBottom:'2px'}}>
                      <div style={{display:'flex',alignItems:'center',justifyContent:'flex-end',paddingRight:'4px',fontSize:'10px',color:'#94a3b8',fontWeight:500}}>
                        {DAY_NAMES[dia-1]}
                      </div>
                      {displayHours.map(h=>{
                        const val = matrix[dia]?.[h] || 0;
                        const bg = val > 0 ? gc(val) : '#f1f5f9';
                        return (
                          <div key={h} title={`${DAY_NAMES[dia-1]} ${h}h: ${val} visitantes`}
                            style={{borderRadius:'3px',background:bg,minHeight:'18px',
                              display:'flex',alignItems:'center',justifyContent:'center',
                              fontSize:'9px',color:val/maxVal>0.5?'#fff':'#64748b'}}>
                            {val > 0 ? val : ''}
                          </div>
                        );
                      })}
                    </div>
                  ))}
                  <div style={{display:'flex',alignItems:'center',gap:'4px',marginTop:'8px',justifyContent:'flex-end',fontSize:'10px',color:'#94a3b8'}}>
                    <span>Menos</span>
                    {[0.05,0.2,0.4,0.6,0.8,1.0].map(i=>(
                      <div key={i} style={{width:'14px',height:'14px',borderRadius:'2px',background:`rgba(30,64,175,${i})`}}/>
                    ))}
                    <span>Más ({maxVal})</span>
                  </div>
                </div>
              );
            })()}
          </div>
        )}

        {/* Widget: Calendario de Visitantes por Mes */}
        <div className="chart-card" style={{gridColumn:'1 / -1'}}>
          {(() => {
            const MONTH_NAMES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
            const DAY_NAMES_SHORT = ['Dom','Lun','Mar','Mié','Jue','Vie','Sáb'];
            const year = calDate.getFullYear();
            const month = calDate.getMonth();
            const firstDay = new Date(year, month, 1).getDay();
            const daysInMonth = new Date(year, month+1, 0).getDate();
            const dateMap: {[k:string]:number} = {};
            weekly.forEach((d:any) => { dateMap[d.date] = d.total_in; });
            chart.forEach((d:any) => { if (!dateMap[d.fecha] && d.flujo > 0) dateMap[d.fecha] = d.flujo; });
            const allVals = Object.entries(dateMap)
              .filter(([k]) => k.startsWith(`${year}-${String(month+1).padStart(2,'0')}`))
              .map(([,v]) => v as number);
            const maxVal = allVals.length > 0 ? Math.max(...allVals) : 1;
            const gc = (v:number) => {
              if (!v) return '#f8fafc';
              return `rgba(30,64,175,${Math.max(0.1,v/maxVal).toFixed(2)})`;
            };
            const cells: React.ReactNode[] = [];
            for (let i=0;i<firstDay;i++) cells.push(<div key={`e${i}`}/>);
            for (let d=1;d<=daysInMonth;d++) {
              const ds = `${year}-${String(month+1).padStart(2,'0')}-${String(d).padStart(2,'0')}`;
              const v = dateMap[ds] || 0;
              cells.push(
                <div key={d} title={v>0?`${ds}: ${v} visitantes`:`${ds}: sin datos`}
                  style={{aspectRatio:'1',borderRadius:'4px',background:gc(v),
                    display:'flex',alignItems:'center',justifyContent:'center',
                    fontSize:'11px',fontWeight:500,
                    color:v/maxVal>0.5?'#fff':'#64748b',
                    border: v===0 ? '1px solid #f1f5f9' : 'none',cursor:'default'}}>
                  {d}
                </div>
              );
            }
            return (
              <div>
                <div style={{display:'flex',alignItems:'center',gap:'12px',marginBottom:'12px'}}>
                  <h3 style={{margin:0}}>🗓 Calendario de Visitantes</h3>
                  <div style={{marginLeft:'auto',display:'flex',alignItems:'center',gap:'8px'}}>
                    <button onClick={()=>setCalDate(new Date(year,month-1,1))}
                      style={{background:'#f1f5f9',border:'none',borderRadius:'6px',padding:'4px 10px',cursor:'pointer',fontSize:'14px',color:'#475569'}}>‹</button>
                    <span style={{fontWeight:600,color:'#1a1a2e',minWidth:'140px',textAlign:'center'}}>
                      {MONTH_NAMES[month]} {year}
                    </span>
                    <button onClick={()=>setCalDate(new Date(year,month+1,1))}
                      style={{background:'#f1f5f9',border:'none',borderRadius:'6px',padding:'4px 10px',cursor:'pointer',fontSize:'14px',color:'#475569'}}>›</button>
                  </div>
                </div>
                <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',gap:'4px'}}>
                  {DAY_NAMES_SHORT.map(d=>(
                    <div key={d} style={{textAlign:'center',fontSize:'10px',color:'#94a3b8',fontWeight:600,paddingBottom:'4px'}}>{d}</div>
                  ))}
                  {cells}
                </div>
                <div style={{display:'flex',alignItems:'center',gap:'4px',marginTop:'12px',justifyContent:'flex-end',fontSize:'10px',color:'#94a3b8'}}>
                  <span>Sin datos</span>
                  {[0.1,0.3,0.5,0.7,0.9,1.0].map(i=>(
                    <div key={i} style={{width:'14px',height:'14px',borderRadius:'2px',background:`rgba(30,64,175,${i})`}}/>
                  ))}
                  <span>Máx: {maxVal}</span>
                </div>
              </div>
            );
          })()}
        </div>

</div>
<div className="chart-card" style={{gridColumn:"1 / -1"}}>
  <h3>Historial Año a Año</h3>
  <div style={{textAlign:"center", padding:"32px 20px", color:"#94a3b8"}}>
    <div style={{fontSize:38, marginBottom:12}}>📊</div>
    <div style={{fontSize:14, fontWeight:600, color:"#64748b", marginBottom:6}}>Recopilando datos historicos...</div>
    <div style={{fontSize:12, lineHeight:1.8}}>
      El sistema ya esta guardando snapshots diarios desde hoy.<br/>
      En 365 dias podras comparar cada dia contra el mismo dia del año anterior.<br/>
      Datos guardados: Flujo, Ventas, Ticket Promedio, Ingresos y Tasa de Conversion.
    </div>
  </div>
</div>

{/* WIDGET TRÁFICO VEREDA */}
{(storeId === 1 || storeId === 2) && (
  <VeredaWidget storeId={storeId} localTotal={summary?.total_in || 0} />
)}


</div>

  );
}


/* LOGIN */
function LoginPage({ onLogin }: { onLogin: (t: string) => void }) {
  const [user, setUser] = useState(''); const [pass, setPass] = useState(''); const [err, setErr] = useState('');
  const submit = async (e: React.FormEvent) => {
    e.preventDefault(); setErr('');
    const fd = new FormData(); fd.append('username', user); fd.append('password', pass);
    const r = await fetch('/api/auth/login', { method: 'POST', body: fd });
    if (r.ok) { const d = await r.json(); localStorage.setItem('pc_token', d.access_token); onLogin(d.access_token); }
    else setErr('Usuario o contraseña incorrectos');
  };
  return (
    <div className="login-bg">
      <div className="login-card">
          <div className='login-logo'><img src='/eye.png' alt='veo360' style={{height:'180px',objectFit:'contain',display:'block',margin:'0 auto'}} /></div>
        <form onSubmit={submit}>
          <input className="login-input" placeholder="Usuario" value={user} onChange={e => setUser(e.target.value)} />
          <input className="login-input" type="password" placeholder="Contraseña" value={pass} onChange={e => setPass(e.target.value)} />
          {err && <div className="login-error">{err}</div>}
          <button className="login-btn" type="submit">Ingresar</button>
        </form>
      </div>
    </div>
  );
}

/* USERS */
function UsersPanel({ token }: { token: string }) {
  const [users, setUsers] = useState<any[]>([]);
  const [newUser, setNewUser] = useState(''); const [newPass, setNewPass] = useState(''); const [msg, setMsg] = useState('');
  const headers = { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' };
  const load = () => fetch('/api/auth/users', { headers }).then(r => r.json()).then(d => setUsers(Array.isArray(d) ? d : [])).catch(()=>{});
  useEffect(() => { load(); }, []);
  const create = async () => {
    const r = await fetch('/api/auth/users', { method: 'POST', headers, body: JSON.stringify({ username: newUser, password: newPass }) });
    setMsg(r.ok ? 'Usuario creado' : 'Error'); setNewUser(''); setNewPass(''); load();
  };
  const del = async (u: string) => { await fetch(`/api/auth/users/${u}`, { method: 'DELETE', headers }); load(); };
  return (
    <div className="users-panel">
      <h2>Gestión de Usuarios</h2>
      <div className="user-form">
        <input placeholder="Usuario" value={newUser} onChange={e => setNewUser(e.target.value)} />
        <input placeholder="Contraseña" type="password" value={newPass} onChange={e => setNewPass(e.target.value)} />
        <button onClick={create}>Crear</button>
        {msg && <span style={{ color: '#4ade80', fontSize: 13 }}>{msg}</span>}
      </div>
      <table><thead><tr><th>Usuario</th><th>Acción</th></tr></thead>
        <tbody>{users.map((u: any) => (
          <tr key={u.username}><td>{u.username}</td>
            <td>{u.username !== 'admin' && <button className="btn-delete" onClick={() => del(u.username)}>Eliminar</button>}</td>
          </tr>
        ))}</tbody>
      </table>
    </div>
  );
}

/* APP */
export default App;

// ============================================================
// MONTHLY GOALS WIDGET
// ============================================================
interface GoalData {
  store_id: number; store_name: string; objetivo: number; objetivo_pares: number;
  logrado: number; esperado: number; avance_pct: number;
  esperado_pct: number; resta_pct: number; faltante: number;
  prev_year_ytd: number; yoy_diff: number; yoy_pct: number;
  anio: number; mes: number;
}
function MonthlyGoalsWidget() {
  const [goals, setGoals] = React.useState<GoalData[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [editingStore, setEditingStore] = React.useState<number|null>(null);
  const [editValue, setEditValue] = React.useState('');
  const [editingStorePares, setEditingStorePares] = React.useState<number|null>(null);
  const [editValuePares, setEditValuePares] = React.useState('');
  const [saving, setSaving] = React.useState(false);
  const [collapsed, setCollapsed] = React.useState(false);
  const mesActual = new Date().toLocaleString('es-AR',{month:'long',year:'numeric'});
  const fetchGoals = () => {
    setLoading(true);
    fetch('/api/goals').then(r=>r.json()).then(d=>{setGoals(d);setLoading(false);}).catch(()=>setLoading(false));
  };
  React.useEffect(()=>{fetchGoals();},[]);
  const fmt = (n:number) => n>=1e6?'$'+(n/1e6).toFixed(1)+'M':n>=1e3?'$'+(n/1e3).toFixed(0)+'K':'$'+n.toFixed(0);
  const fmtFull = (n:number) => '$'+Math.round(n).toLocaleString('es-AR');
  const handleSave = (sid:number,anio:number,mes:number) => {
    const v=parseFloat(editValue.replace(/\./g,'').replace(',','.'));
    if(isNaN(v)||v<0)return;
    const g=goals.find(x=>x.store_id===sid);
    setSaving(true);
    fetch(`/api/goals/${sid}`,{method:'PUT',headers:{'Content-Type':'application/json'},body:JSON.stringify({objetivo:v,anio,mes,objetivo_pares:g?.objetivo_pares||0})})
      .then(()=>{setEditingStore(null);setEditValue('');fetchGoals();}).finally(()=>setSaving(false));
  };
  const handleSavePares = (sid:number,anio:number,mes:number) => {
    const v=parseInt(editValuePares.replace(/\D/g,''));
    if(isNaN(v)||v<0)return;
    const g=goals.find(x=>x.store_id===sid);
    setSaving(true);
    fetch(`/api/goals/${sid}`,{method:'PUT',headers:{'Content-Type':'application/json'},body:JSON.stringify({objetivo:g?.objetivo||0,anio,mes,objetivo_pares:v})})
      .then(()=>{setEditingStorePares(null);setEditValuePares('');fetchGoals();}).finally(()=>setSaving(false));
  };
  const totObj=goals.reduce((s,g)=>s+g.objetivo,0);
  const totPares=goals.reduce((s,g)=>s+(g.objetivo_pares||0),0);
  const totLog=goals.reduce((s,g)=>s+g.logrado,0);
  const totEsp=goals.reduce((s,g)=>s+g.esperado,0);
  const totPrev=goals.reduce((s,g)=>s+g.prev_year_ytd,0);
  const totAvPct=totObj>0?(totLog/totObj*100):0;
  const totEspPct=totObj>0?(totEsp/totObj*100):0;
  const S:React.CSSProperties={};
  return (
    <div style={{background:'#1a1a2e',border:'1px solid #2a2a4a',borderRadius:'12px',marginBottom:'24px',overflow:'hidden',boxShadow:'0 4px 20px rgba(0,0,0,0.4)'}}>
      <div style={{background:'linear-gradient(135deg,#16213e,#0f3460)',padding:'16px 20px',display:'flex',alignItems:'center',justifyContent:'space-between',cursor:'pointer'}} onClick={()=>setCollapsed(!collapsed)}>
        <div style={{display:'flex',alignItems:'center',gap:'12px'}}>
          <span style={{fontSize:'22px'}}>🎯</span>
          <div>
            <div style={{color:'#e2e8f0',fontWeight:700,fontSize:'16px'}}>Objetivos Mensuales</div>
            <div style={{color:'#94a3b8',fontSize:'12px',textTransform:'capitalize'}}>{mesActual}</div>
          </div>
        </div>
        <div style={{display:'flex',alignItems:'center',gap:'20px'}}>
          {totObj>0&&<div style={{textAlign:'right'}}>
            <div style={{color:'#94a3b8',fontSize:'11px'}}>PROGRESO TOTAL</div>
            <div style={{color:totAvPct>=totEspPct?'#4ade80':'#f87171',fontSize:'20px',fontWeight:700}}>{totAvPct.toFixed(1)}%</div>
          </div>}
          <span style={{color:'#64748b',fontSize:'18px'}}>{collapsed?'▶':'▼'}</span>
        </div>
      </div>
      {!collapsed&&<div style={{padding:'16px 20px'}}>
        {loading?<div style={{color:'#64748b',textAlign:'center',padding:'20px'}}>Cargando datos de la API Niko...</div>:<>
          {totObj>0&&<div style={{marginBottom:'20px'}}>
            <div style={{display:'flex',justifyContent:'space-between',marginBottom:'6px'}}>
              <span style={{color:'#94a3b8',fontSize:'12px'}}>Total: {fmtFull(totLog)} / {fmtFull(totObj)}</span>
              <span style={{color:'#94a3b8',fontSize:'12px'}}>Esperado: {fmtFull(totEsp)} ({totEspPct.toFixed(1)}%)</span>
            </div>
            <div style={{height:'14px',background:'#0f172a',borderRadius:'7px',overflow:'hidden',position:'relative'}}>
              <div style={{position:'absolute',left:`${Math.min(totEspPct,100)}%`,top:0,bottom:0,width:'2px',background:'#f59e0b',zIndex:2}}/>
              <div style={{height:'100%',width:`${Math.min(totAvPct,100)}%`,background:totAvPct>=totEspPct?'linear-gradient(90deg,#059669,#4ade80)':'linear-gradient(90deg,#dc2626,#f87171)',borderRadius:'7px',transition:'width 0.6s ease'}}/>
            </div>
            <div style={{display:'flex',justifyContent:'space-between',marginTop:'4px'}}>
              <span style={{color:totAvPct>=totEspPct?'#4ade80':'#f87171',fontSize:'13px',fontWeight:600}}>{totAvPct>=totEspPct?'✓ En objetivo':'⚠ Por debajo del esperado'}</span>
              <span style={{color:'#64748b',fontSize:'12px'}}>Faltante: {fmtFull(totObj-totLog)}</span>
            </div>
          </div>}
          <div style={{overflowX:'auto'}}>
            <table style={{width:'100%',borderCollapse:'collapse',fontSize:'13px'}}>
              <thead><tr style={{borderBottom:'1px solid #2a2a4a'}}>
                {['Local','Objetivo mes','Obj. Pares','Log. Pares','Logrado','Avance %','Esperado %','Faltante','vs 2025','YoY %',''].map(h=>(
                  <th key={h} style={{padding:'8px 10px',color:'#64748b',fontWeight:600,textAlign:h==='Local'?'left':'right',whiteSpace:'nowrap'}}>{h}</th>
                ))}
              </tr></thead>
              <tbody>
                {goals.map(g=>{
                  const ok=g.avance_pct>=g.esperado_pct;
                  const ed=editingStore===g.store_id;
                  return(<tr key={g.store_id} style={{borderBottom:'1px solid #1e293b'}}>
                    <td style={{padding:'10px',color:'#e2e8f0',fontWeight:600}}>{g.store_name}</td>
                    <td style={{padding:'10px',textAlign:'right'}}>
                      {ed?<div style={{display:'flex',gap:'4px',justifyContent:'flex-end'}}>
                        <input type="text" value={editValue} onChange={e=>setEditValue(e.target.value)}
                          onKeyDown={e=>{if(e.key==='Enter')handleSave(g.store_id,g.anio,g.mes);if(e.key==='Escape')setEditingStore(null);}}
                          autoFocus placeholder="ej: 60000000"
                          style={{background:'#0f172a',border:'1px solid #3b82f6',color:'#e2e8f0',borderRadius:'4px',padding:'3px 6px',width:'120px',fontSize:'12px'}}/>
                        <button onClick={()=>handleSave(g.store_id,g.anio,g.mes)} disabled={saving}
                          style={{background:'#3b82f6',color:'#fff',border:'none',borderRadius:'4px',padding:'3px 8px',cursor:'pointer',fontSize:'12px'}}>{saving?'...':'✓'}</button>
                        <button onClick={()=>setEditingStore(null)}
                          style={{background:'#374151',color:'#fff',border:'none',borderRadius:'4px',padding:'3px 6px',cursor:'pointer',fontSize:'12px'}}>✕</button>
                      </div>:<span style={{color:g.objetivo>0?'#e2e8f0':'#475569'}}>{g.objetivo>0?fmtFull(g.objetivo):'—'}</span>}
                    </td>
                    <td style={{padding:'10px',textAlign:'right',cursor:'pointer'}} onClick={()=>{if(editingStorePares!==g.store_id){setEditingStorePares(g.store_id);setEditValuePares(g.objetivo_pares>0?String(g.objetivo_pares):'');}}}>{editingStorePares===g.store_id?<div style={{display:'flex',gap:'4px',justifyContent:'flex-end'}} onClick={e=>e.stopPropagation()}>
                  <input type="text" value={editValuePares} onChange={e=>setEditValuePares(e.target.value)}
                    onKeyDown={e=>{if(e.key==='Enter')handleSavePares(g.store_id,g.anio,g.mes);if(e.key==='Escape')setEditingStorePares(null);}}
                    autoFocus placeholder="ej: 500"
                    style={{background:'#0f172a',border:'1px solid #3b82f6',color:'#e2e8f0',borderRadius:'4px',padding:'3px 6px',width:'80px',fontSize:'12px'}}/>
                  <button onClick={()=>handleSavePares(g.store_id,g.anio,g.mes)} disabled={saving}
                    style={{background:'#3b82f6',color:'#fff',border:'none',borderRadius:'4px',padding:'3px 8px',cursor:'pointer',fontSize:'12px'}}>{saving?'...':'✓'}</button>
                  <button onClick={()=>setEditingStorePares(null)}
                    style={{background:'#374151',color:'#fff',border:'none',borderRadius:'4px',padding:'3px 6px',cursor:'pointer',fontSize:'12px'}}>✕</button>
                </div>:<span style={{color:g.objetivo_pares>0?'#e2e8f0':'#475569'}}>{g.objetivo_pares>0?g.objetivo_pares.toLocaleString('es-AR'):'-'}</span>}
              </td>
              <td style={{padding:'10px',textAlign:'right',color:'#475569'}}>-</td>
              <td style={{padding:'10px',textAlign:'right',color:'#e2e8f0'}}>{fmt(g.logrado)}</td>
                    <td style={{padding:'10px',textAlign:'right'}}>
                      <div style={{display:'flex',flexDirection:'column',alignItems:'flex-end',gap:'3px'}}>
                        <span style={{color:g.objetivo>0?(ok?'#4ade80':'#f87171'):'#475569',fontWeight:700}}>{g.objetivo>0?g.avance_pct.toFixed(1)+'%':'—'}</span>
                        {g.objetivo>0&&<div style={{width:'80px',height:'5px',background:'#0f172a',borderRadius:'3px',overflow:'hidden',position:'relative'}}>
                          <div style={{position:'absolute',left:`${Math.min(g.esperado_pct,100)}%`,top:0,bottom:0,width:'2px',background:'#f59e0b',zIndex:2}}/>
                          <div style={{height:'100%',width:`${Math.min(g.avance_pct,100)}%`,background:ok?'#4ade80':'#f87171',borderRadius:'3px'}}/>
                        </div>}
                      </div>
                    </td>
                    <td style={{padding:'10px',textAlign:'right',color:'#f59e0b'}}>{g.objetivo>0?g.esperado_pct.toFixed(1)+'%':'—'}</td>
                    <td style={{padding:'10px',textAlign:'right',color:g.objetivo>0?'#f87171':'#475569'}}>{g.objetivo>0?fmt(g.faltante):'—'}</td>
                    <td style={{padding:'10px',textAlign:'right'}}>
                      <span style={{color:g.yoy_diff>=0?'#4ade80':'#f87171',fontWeight:600}}>{g.yoy_diff>=0?'+':''}{fmt(g.yoy_diff)}</span>
                    </td>
                    <td style={{padding:'10px',textAlign:'right'}}>
                      <span style={{background:g.yoy_pct>=0?'rgba(74,222,128,0.15)':'rgba(248,113,113,0.15)',color:g.yoy_pct>=0?'#4ade80':'#f87171',padding:'2px 6px',borderRadius:'4px',fontWeight:600,fontSize:'12px'}}>
                        {g.yoy_pct>=0?'+':''}{g.yoy_pct.toFixed(1)}%
                      </span>
                    </td>
                    <td style={{padding:'10px 6px',textAlign:'center'}}>
                      <button onClick={()=>{setEditingStore(g.store_id);setEditValue(g.objetivo>0?String(Math.round(g.objetivo)):'');}} title="Cargar objetivo"
                        style={{background:'transparent',border:'1px solid #334155',color:'#64748b',borderRadius:'4px',padding:'3px 7px',cursor:'pointer',fontSize:'12px'}}>✏️</button>
                    </td>
                  </tr>);
                })}
                <tr style={{borderTop:'2px solid #2a2a4a',background:'#0f172a'}}>
                  <td style={{padding:'10px',color:'#94a3b8',fontWeight:700}}>TOTAL</td>
                  <td style={{padding:'10px',textAlign:'right',color:'#94a3b8',fontWeight:700}}>{totObj>0?fmtFull(totObj):'—'}</td>
                  <td style={{padding:'10px',textAlign:'right',color:'#94a3b8',fontWeight:700}}>{totPares>0?totPares.toLocaleString('es-AR'):'—'}</td>
              <td style={{padding:'10px',textAlign:'right',color:'#94a3b8',fontWeight:700}}>—</td>
              <td style={{padding:'10px',textAlign:'right',color:'#e2e8f0',fontWeight:700}}>{fmt(totLog)}</td>
                  <td style={{padding:'10px',textAlign:'right'}}><span style={{color:totAvPct>=totEspPct?'#4ade80':'#f87171',fontWeight:700}}>{totObj>0?totAvPct.toFixed(1)+'%':'—'}</span></td>
                  <td style={{padding:'10px',textAlign:'right',color:'#f59e0b',fontWeight:700}}>{totObj>0?totEspPct.toFixed(1)+'%':'—'}</td>
                  <td style={{padding:'10px',textAlign:'right',color:'#f87171',fontWeight:700}}>{totObj>0?fmt(totObj-totLog):'—'}</td>
                  <td style={{padding:'10px',textAlign:'right'}}><span style={{color:(totLog-totPrev)>=0?'#4ade80':'#f87171',fontWeight:700}}>{(totLog-totPrev)>=0?'+':''}{fmt(totLog-totPrev)}</span></td>
                  <td style={{padding:'10px',textAlign:'right'}}>{totPrev>0&&<span style={{background:(totLog-totPrev)>=0?'rgba(74,222,128,0.15)':'rgba(248,113,113,0.15)',color:(totLog-totPrev)>=0?'#4ade80':'#f87171',padding:'2px 6px',borderRadius:'4px',fontWeight:700,fontSize:'12px'}}>{((totLog-totPrev)/totPrev*100)>=0?'+':''}{((totLog-totPrev)/totPrev*100).toFixed(1)}%</span>}</td>
                  <td/>
                </tr>
              </tbody>
            </table>
          </div>
          <div style={{marginTop:'12px',color:'#475569',fontSize:'11px',textAlign:'right'}}>✏️ = cargar objetivo · 🟡 marca el progreso esperado · verde/rojo = vs objetivo</div>
        </>}
      </div>}
    </div>
  );
}
// ============================================================
// END MONTHLY GOALS WIDGET
// ============================================================








// ============================================================
// SELLER GOALS WIDGET v2
// ============================================================
interface SellerData {
  seller_name: string; vendedor_id: number|null; pct_objetivo: number;
  objetivo: number; logrado: number; avance_pct: number;
  linear_expected_pct: number; on_track: boolean; faltante: number;
}
interface StoreSellerData {
  store_id: number; store_name: string; store_objetivo: number;
  store_logrado: number; total_pct_asignado: number; sellers: SellerData[];
}
interface ApiSeller {
  vendedor_id: number; vendedor: string; monto: number; cantidad_ventas: number;
}
// ============================================================
// SELLER GOALS WIDGET - NUEVO
// ============================================================

interface SellerRow {
  vendedor_id: string;
  nombre: string;
  puesto: string; // 'Vendedor' | 'Cajero' | 'Encargado'
  store_id: number;
  store_name: string;
  logrado: number;
  objetivo: number;
  obj_acc1: number; obj_acc2: number; obj_indum: number; obj_calzado: number; obj_bolsas: number;
  log_acc1: number; log_acc2: number; log_indum: number; log_calzado: number; log_bolsas: number;
  anio: number; mes: number;
}

const STORES_VEN = [
  {store_id:6, name:'Niko 1'},
  {store_id:3, name:'Niko 2'},
  {store_id:1, name:'Niko 3'},
  {store_id:2, name:'Niko 4'},
  {store_id:4, name:'Niko 5'},
  {store_id:5, name:'Niko 7'},
];

function fmtV(n:number):string {
  if (!n || n===0) return '-';
  if (n>=1000000) return '$'+(n/1000000).toFixed(1)+'M';
  if (n>=1000) return '$'+(n/1000).toFixed(0)+'K';
  return '$'+n.toLocaleString('es-AR');
}

function SellerGoalsWidget() {
  const now = new Date();
  const [anio, setAnio] = React.useState(now.getFullYear());
  const [mes, setMes]   = React.useState(now.getMonth()+1);
  const [rows, setRows] = React.useState<SellerRow[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [editCell, setEditCell] = React.useState<{id:string,field:string}|null>(null);
  const [editVal, setEditVal]   = React.useState('');
  const [saving, setSaving]     = React.useState(false);
  const [collapsed, setCollapsed] = React.useState(false);
  const token = localStorage.getItem('pc_token')||'';

  const MESES = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];

  // Load all sellers from API + saved goals from DB
  const loadData = React.useCallback(() => {
    setLoading(true);
    const headers = {'Authorization':'Bearer '+token,'Content-Type':'application/json'};
    // Load saved goals
    fetch(`/api/seller-goals?year=${anio}&month=${mes}`,{headers})
      .then(r=>r.json())
      .then((goals:any[]) => {
        // Load sellers from API for all stores
        Promise.all(
          STORES_VEN.map(st =>
            fetch(`/api/seller-goals/sellers?store_id=${st.store_id}`,{headers})
              .then(r=>r.json())
              .then((sellers:any[]) => sellers.map((s:any) => ({
                ...s,
                store_id: st.store_id,
                store_name: st.name
              })))
              .catch(()=>[])
          )
        ).then(results => {
          const allSellers = results.flat();
          const merged:SellerRow[] = allSellers.map((s:any) => {
            const g = goals.find((g:any) => g.vendedor_id===s.vendedor_id && g.store_id===s.store_id) || {};
            return {
              vendedor_id: s.vendedor_id,
              nombre: s.vendedor,
              puesto: g.puesto || s.puesto || 'Vendedor',
              store_id: s.store_id,
              store_name: s.store_name,
              logrado: s.monto || 0,
              objetivo: g.objetivo || 0,
              obj_acc1: g.obj_acc1||0, obj_acc2: g.obj_acc2||0,
              obj_indum: g.obj_indum||0, obj_calzado: g.obj_calzado||0, obj_bolsas: g.obj_bolsas||0,
              log_acc1: s.log_acc1||0, log_acc2: s.log_acc2||0,
              log_indum: s.log_indum||0, log_calzado: s.log_calzado||0, log_bolsas: s.log_bolsas||0,
              anio, mes
            };
          });
          // Sort by store order then by logrado desc
          merged.sort((a,b) => {
            const storeOrder = STORES_VEN.findIndex(s=>s.store_id===a.store_id) - STORES_VEN.findIndex(s=>s.store_id===b.store_id);
            if (storeOrder!==0) return storeOrder;
            return b.logrado - a.logrado;
          });
          setRows(merged);
          setLoading(false);
        });
      })
      .catch(()=>setLoading(false));
  },[anio,mes,token]);

  React.useEffect(()=>{ loadData(); },[loadData]);

  const startEdit = (id:string, field:string, current:number) => {
    setEditCell({id,field});
    setEditVal(current>0?String(current):'');
  };

  const saveEdit = async () => {
    if (!editCell) return;
    setSaving(true);
    const row = rows.find(r=>r.vendedor_id===editCell.id);
    if (!row) { setSaving(false); return; }
    const updated = {...row, [editCell.field]: Number(editVal)||0};
    try {
      await fetch('/api/seller-goals', {
        method:'PUT',
        headers:{'Authorization':'Bearer '+token,'Content-Type':'application/json'},
        body: JSON.stringify({
          vendedor_id: row.vendedor_id,
          store_id: row.store_id,
          nombre: row.nombre,
          puesto: row.puesto,
          anio, mes,
          objetivo: updated.objetivo,
          obj_acc1: updated.obj_acc1,
          obj_acc2: updated.obj_acc2,
          obj_indum: updated.obj_indum,
          obj_calzado: updated.obj_calzado,
          obj_bolsas: updated.obj_bolsas,
        })
      });
      setRows(prev => prev.map(r => r.vendedor_id===row.vendedor_id && r.store_id===row.store_id ? updated : r));
    } finally {
      setSaving(false);
      setEditCell(null);
      setEditVal('');
    }
  };

  const cancelEdit = () => { setEditCell(null); setEditVal(''); };

  // Group rows by store
  const byStore: {[key:number]: SellerRow[]} = {};
  STORES_VEN.forEach(st => { byStore[st.store_id] = rows.filter(r=>r.store_id===st.store_id); });

  const PUESTO_COLOR: {[k:string]:string} = {
    'Encargado':'#fb923c', 'Cajero':'#34d399', 'Vendedor':'#38bdf8'
  };
  const PUESTO_BG: {[k:string]:string} = {
    'Encargado':'rgba(251,146,60,0.18)', 'Cajero':'rgba(52,211,153,0.15)', 'Vendedor':'transparent'
  };

  const EditableCell = ({row, field, isUnits=false}:{row:SellerRow,field:string,isUnits?:boolean}) => {
    const val = (row as any)[field] as number;
    const isEditing = editCell?.id===row.vendedor_id && editCell?.field===field;
    if (isEditing) return (
      <div style={{display:'flex',gap:'3px',alignItems:'center'}}>
        <input autoFocus type="number" value={editVal} onChange={e=>setEditVal(e.target.value)}
          onKeyDown={e=>{if(e.key==='Enter')saveEdit();if(e.key==='Escape')cancelEdit();}}
          style={{width:'70px',padding:'2px 4px',background:'#1e293b',color:'#e2e8f0',border:'1px solid #3b82f6',borderRadius:'3px',fontSize:'11px'}}/>
        <button onClick={saveEdit} disabled={saving}
          style={{background:'#3b82f6',color:'#fff',border:'none',borderRadius:'3px',padding:'2px 5px',cursor:'pointer',fontSize:'10px'}}>{saving?'...':'✓'}</button>
        <button onClick={cancelEdit}
          style={{background:'#374151',color:'#fff',border:'none',borderRadius:'3px',padding:'2px 4px',cursor:'pointer',fontSize:'10px'}}>✕</button>
      </div>
    );
    return (
      <span onClick={()=>startEdit(row.vendedor_id,field,val)}
        style={{cursor:'pointer',color:val>0?'#e2e8f0':'#475569',display:'block',width:'100%',textAlign:'right',padding:'2px 4px',borderRadius:'3px'}}
        title="Click para editar">
        {isUnits ? (val>0?val.toLocaleString('es-AR'):'-') : (val>0?fmtV(val):'-')}
      </span>
    );
  };

  const thStyle = (center=false):React.CSSProperties => ({
    padding:'6px 8px', color:'#64748b', fontWeight:600, fontSize:'10px',
    textAlign: center?'center':'right', whiteSpace:'nowrap', borderBottom:'1px solid #1e293b'
  });
  const tdStyle = (center=false, bg='transparent'):React.CSSProperties => ({
    padding:'5px 8px', fontSize:'12px', textAlign: center?'center':'right',
    borderBottom:'1px solid #0f172a', background:bg, verticalAlign:'middle'
  });

  return (
    <div style={{background:'#0f172a',borderRadius:'12px',overflow:'hidden',boxShadow:'0 4px 20px rgba(0,0,0,0.4)',marginTop:'12px'}}>
      {/* HEADER */}
      <div style={{background:'linear-gradient(135deg,#1e1b4b,#312e81)',padding:'14px 18px',display:'flex',alignItems:'center',justifyContent:'space-between',cursor:'pointer'}}
        onClick={()=>setCollapsed(!collapsed)}>
        <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
          <span style={{fontSize:'20px'}}>👥</span>
          <div>
            <div style={{color:'#e2e8f0',fontWeight:700,fontSize:'15px'}}>Objetivos por Vendedor</div>
            <div style={{color:'#94a3b8',fontSize:'11px'}}>{rows.length} vendedores · {MESES[mes-1]} {anio}</div>
          </div>
        </div>
        <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
          {/* Month/Year selector */}
          <select value={mes} onChange={e=>{setMes(Number(e.target.value));}}
            onClick={e=>e.stopPropagation()}
            style={{background:'#1e293b',color:'#e2e8f0',border:'1px solid #334155',borderRadius:'6px',padding:'4px 8px',fontSize:'12px'}}>
            {MESES.map((m,i)=><option key={i+1} value={i+1}>{m}</option>)}
          </select>
          <select value={anio} onChange={e=>{setAnio(Number(e.target.value));}}
            onClick={e=>e.stopPropagation()}
            style={{background:'#1e293b',color:'#e2e8f0',border:'1px solid #334155',borderRadius:'6px',padding:'4px 8px',fontSize:'12px'}}>
            {[2024,2025,2026,2027].map(y=><option key={y} value={y}>{y}</option>)}
          </select>
          <span style={{color:'#94a3b8',fontSize:'18px'}}>{collapsed?'▶':'▼'}</span>
        </div>
      </div>

      {!collapsed && (
        <div style={{padding:'0',overflowX:'auto'}}>
          {loading ? (
            <div style={{color:'#64748b',textAlign:'center',padding:'30px'}}>Cargando vendedores...</div>
          ) : rows.length===0 ? (
            <div style={{color:'#475569',textAlign:'center',padding:'30px'}}>No hay datos disponibles.</div>
          ) : (
            <table style={{width:'100%',borderCollapse:'collapse',minWidth:'900px'}}>
              <thead>
                <tr style={{background:'#0a0f1e'}}>
                  <th style={{...thStyle(false),textAlign:'left'}}>SUCURSAL</th>
                  <th style={{...thStyle(true)}}>PUESTO</th>
                  <th style={{...thStyle(false),textAlign:'left'}}>NOMBRE</th>
                  <th style={thStyle()}>OBJ. $</th>
                  <th style={thStyle()}>LOGRADO $</th>
                  <th style={{...thStyle(true),minWidth:'110px'}}>AVANCE</th>
                  <th style={thStyle()}>Ac1 obj/log</th>
                  <th style={thStyle()}>Ac2 obj/log</th>
                  <th style={thStyle()}>Indum obj/log</th>
                  <th style={thStyle()}>Calz obj/log</th>
                  <th style={thStyle()}>Bolsas obj/log</th>
                </tr>
              </thead>
              <tbody>
                {STORES_VEN.map(st => {
                  const storeRows = byStore[st.store_id] || [];
                  if (storeRows.length===0) return null;
                  const storeObj = storeRows.reduce((s,r)=>s+(r.objetivo||0),0);
                  const storeLog = storeRows.reduce((s,r)=>s+(r.logrado||0),0);
                  const storePct = storeObj>0?(storeLog/storeObj*100):0;
                  return (
                    <React.Fragment key={st.store_id}>
                      {/* Store header row */}
                      <tr style={{background:'#1e1b4b'}}>
                        <td colSpan={3} style={{padding:'6px 10px',color:'#818cf8',fontWeight:700,fontSize:'12px',borderBottom:'1px solid #312e81'}}>
                          📍 {st.name}
                        </td>
                        <td style={{padding:'6px 8px',color:'#94a3b8',fontSize:'11px',textAlign:'right',borderBottom:'1px solid #312e81'}}>
                          {storeObj>0?fmtV(storeObj):'—'}
                        </td>
                        <td style={{padding:'6px 8px',color:'#e2e8f0',fontSize:'11px',textAlign:'right',borderBottom:'1px solid #312e81'}}>
                          {fmtV(storeLog)}
                        </td>
                        <td style={{padding:'6px 8px',textAlign:'center',borderBottom:'1px solid #312e81'}}>
                          {storeObj>0 && (
                            <span style={{color:storePct>=67?'#4ade80':'#f87171',fontWeight:700,fontSize:'11px'}}>
                              {storePct.toFixed(1)}%
                            </span>
                          )}
                        </td>
                        <td colSpan={5} style={{borderBottom:'1px solid #312e81'}}></td>
                      </tr>
                      {/* Seller rows */}
                      {storeRows.map((row,i) => {
                        const pct = row.objetivo>0?(row.logrado/row.objetivo*100):0;
                        const color = PUESTO_COLOR[row.puesto]||'#e2e8f0';
                        const bg = i%2===0?'#0d1117':'#0a0f1e';
                        const rowBg = PUESTO_BG[row.puesto]||bg;
                        return (
                          <tr key={row.vendedor_id} style={{background:rowBg}}>
                            <td style={{...tdStyle(false,rowBg),color:'#475569',fontSize:'11px'}}>{row.store_name}</td>
                            <td style={{...tdStyle(true,rowBg)}}>
                              <span style={{color,fontSize:'10px',fontWeight:600,background:PUESTO_BG[row.puesto]||'transparent',padding:'2px 6px',borderRadius:'10px',border:`1px solid ${color}40`}}>
                                {row.puesto}
                              </span>
                            </td>
                            <td style={{...tdStyle(false,rowBg),textAlign:'left',color:'#e2e8f0',fontWeight:row.puesto==='Encargado'?600:400}}>
                              {row.nombre}
                            </td>
                            {/* OBJ $ */}
                            <td style={tdStyle(false,rowBg)}>
                              <EditableCell row={row} field="objetivo" />
                            </td>
                            {/* LOGRADO $ */}
                            <td style={{...tdStyle(false,rowBg),color:'#e2e8f0'}}>
                              {fmtV(row.logrado)}
                            </td>
                            {/* BARRA AVANCE */}
                            <td style={{...tdStyle(true,rowBg),minWidth:'110px'}}>
                              {row.objetivo>0?(
                                <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:'2px'}}>
                                  <span style={{color:pct>=67?'#4ade80':'#f87171',fontWeight:700,fontSize:'11px'}}>{pct.toFixed(1)}%</span>
                                  <div style={{width:'90px',height:'5px',background:'#1e293b',borderRadius:'3px',overflow:'hidden'}}>
                                    <div style={{width:`${Math.min(pct,100)}%`,height:'100%',background:pct>=67?'#4ade80':'#f87171',borderRadius:'3px'}}></div>
                                  </div>
                                </div>
                              ):<span style={{color:'#334155',fontSize:'11px'}}>—</span>}
                            </td>
                            {/* ACCESORIOS 1 */}
                            <td style={tdStyle(false,rowBg)}>
                              <div style={{display:'flex',flexDirection:'column',gap:'1px'}}>
                                <EditableCell row={row} field="obj_acc1" isUnits />
                                <span style={{color:'#64748b',fontSize:'10px',textAlign:'right'}}>{row.log_acc1>0?row.log_acc1.toLocaleString('es-AR'):'—'}</span>
                              </div>
                            </td>
                            {/* ACCESORIOS 2 */}
                            <td style={tdStyle(false,rowBg)}>
                              <div style={{display:'flex',flexDirection:'column',gap:'1px'}}>
                                <EditableCell row={row} field="obj_acc2" isUnits />
                                <span style={{color:'#64748b',fontSize:'10px',textAlign:'right'}}>{row.log_acc2>0?row.log_acc2.toLocaleString('es-AR'):'—'}</span>
                              </div>
                            </td>
                            {/* INDUMENTARIA */}
                            <td style={tdStyle(false,rowBg)}>
                              <div style={{display:'flex',flexDirection:'column',gap:'1px'}}>
                                <EditableCell row={row} field="obj_indum" isUnits />
                                <span style={{color:'#64748b',fontSize:'10px',textAlign:'right'}}>{row.log_indum>0?row.log_indum.toLocaleString('es-AR'):'—'}</span>
                              </div>
                            </td>
                            {/* CALZADO */}
                            <td style={tdStyle(false,rowBg)}>
                              <div style={{display:'flex',flexDirection:'column',gap:'1px'}}>
                                <EditableCell row={row} field="obj_calzado" isUnits />
                                <span style={{color:'#64748b',fontSize:'10px',textAlign:'right'}}>{row.log_calzado>0?row.log_calzado.toLocaleString('es-AR'):'—'}</span>
                              </div>
                            </td>
                            {/* BOLSAS */}
                            <td style={tdStyle(false,rowBg)}>
                              <div style={{display:'flex',flexDirection:'column',gap:'1px'}}>
                                <EditableCell row={row} field="obj_bolsas" isUnits />
                                <span style={{color:'#64748b',fontSize:'10px',textAlign:'right'}}>{row.log_bolsas>0?row.log_bolsas.toLocaleString('es-AR'):'—'}</span>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          )}
          <div style={{padding:'8px 12px',color:'#334155',fontSize:'10px',textAlign:'right'}}>
            ✏️ = click para editar objetivo · logrado en gris debajo = dato de API (próximamente)
          </div>
        </div>
      )}
    </div>
  );
}

// END SELLER GOALS WIDGET
// ============================================================



// ============================================================
// CAMERA MONITOR WIDGET
// ============================================================

const CAM_LIST: { id: number; sucursal: string; nombre: string; tipo: 'entrada'|'interior'|'vereda'|'deposito' }[] = [
  { id: 6,  sucursal: 'Niko 1', nombre: 'Principal', tipo: 'entrada'  },
  { id: 9,  sucursal: 'Niko 1', nombre: 'Cam 2',     tipo: 'interior' },
  { id: 10, sucursal: 'Niko 1', nombre: 'Cam 3',     tipo: 'interior' },
  { id: 3,  sucursal: 'Niko 2', nombre: 'Principal', tipo: 'entrada'  },
  { id: 11, sucursal: 'Niko 2', nombre: 'Cam 2',     tipo: 'interior' },
  { id: 12, sucursal: 'Niko 2', nombre: 'Cam 3',     tipo: 'interior' },
  { id: 1,  sucursal: 'Niko 3', nombre: 'Principal', tipo: 'entrada'  },
  { id: 13, sucursal: 'Niko 3', nombre: 'Cam 2',     tipo: 'interior' },
  { id: 14, sucursal: 'Niko 3', nombre: 'Cam 3',     tipo: 'interior' },
  { id: 22, sucursal: 'Niko 3', nombre: 'Vereda',    tipo: 'vereda'   },
  { id: 2,  sucursal: 'Niko 4', nombre: 'Principal', tipo: 'entrada'  },
  { id: 15, sucursal: 'Niko 4', nombre: 'Cam 2',     tipo: 'interior' },
  { id: 16, sucursal: 'Niko 4', nombre: 'Cam 3',     tipo: 'interior' },
  { id: 23, sucursal: 'Niko 4', nombre: 'Vereda',    tipo: 'vereda'   },
  { id: 4,  sucursal: 'Niko 5', nombre: 'Principal', tipo: 'entrada'  },
  { id: 17, sucursal: 'Niko 5', nombre: 'Cam 2',     tipo: 'interior' },
  { id: 18, sucursal: 'Niko 5', nombre: 'Cam 3',     tipo: 'interior' },
  { id: 20, sucursal: 'Niko 5', nombre: 'Deposito',  tipo: 'deposito' },
  { id: 7,  sucursal: 'Niko 6', nombre: 'Principal', tipo: 'entrada'  },
  { id: 5,  sucursal: 'Niko 7', nombre: 'Principal', tipo: 'entrada'  },
  { id: 8,  sucursal: 'Niko 7', nombre: 'Ingreso',   tipo: 'entrada'  },
  { id: 19, sucursal: 'Niko 7', nombre: 'Cam 2',     tipo: 'interior' },
  { id: 21, sucursal: 'Niko 7', nombre: 'Deposito',  tipo: 'deposito' },
];

type CamSt = { online: boolean; lastSeen: string|null; todayTotal: number; hadYesterday: boolean };
const CAM_TIPO_ICON: Record<string,string> = { entrada:'🚪', interior:'🏪', vereda:'🚶', deposito:'📦' };





function CameraMonitorWidget() {
  const CAMERAS = [
    {branch:'Niko 1', id:6,  name:'Principal', tipo:'RTSP'},
    {branch:'Niko 1', id:9,  name:'Cam2',      tipo:'IMOU'},
    {branch:'Niko 1', id:10, name:'Cam3',      tipo:'IMOU'},
    {branch:'Niko 2', id:3,  name:'Principal', tipo:'RTSP'},
    {branch:'Niko 2', id:11, name:'Cam2',      tipo:'IMOU'},
    {branch:'Niko 2', id:12, name:'Cam3',      tipo:'IMOU'},
    {branch:'Niko 3', id:1,  name:'Principal', tipo:'RTSP'},
    {branch:'Niko 3', id:13, name:'Cam2',      tipo:'IMOU'},
    {branch:'Niko 3', id:14, name:'Cam3',      tipo:'IMOU'},
    {branch:'Niko 3', id:22, name:'Vereda',    tipo:'RTSP'},
    {branch:'Niko 4', id:2,  name:'Principal', tipo:'RTSP'},
    {branch:'Niko 4', id:15, name:'Cam2',      tipo:'IMOU'},
    {branch:'Niko 4', id:16, name:'Cam3',      tipo:'IMOU'},
    {branch:'Niko 4', id:23, name:'Vereda',    tipo:'RTSP'},
    {branch:'Niko 5', id:4,  name:'Principal', tipo:'RTSP'},
    {branch:'Niko 5', id:17, name:'Cam2',      tipo:'IMOU'},
    {branch:'Niko 5', id:18, name:'Cam3',      tipo:'IMOU'},
    {branch:'Niko 5', id:20, name:'Deposito',  tipo:'IMOU'},
    {branch:'Niko 6', id:7,  name:'Principal', tipo:'RTSP'},
    {branch:'Niko 7', id:5,  name:'Principal', tipo:'RTSP'},
    {branch:'Niko 7', id:8,  name:'Ingreso',   tipo:'RTSP'},
    {branch:'Niko 7', id:19, name:'Cam2',      tipo:'IMOU'},
    {branch:'Niko 7', id:21, name:'Deposito',  tipo:'IMOU'},
  ] as const;
  type CamId = typeof CAMERAS[number]['id'];
  type CamStatus = 'online' | 'sin-datos' | 'offline' | 'loading';
  const [statuses, setStatuses] = React.useState<Partial<Record<CamId,CamStatus>>>({});
  const [lastCheck, setLastCheck] = React.useState('');
  const alertSent = React.useRef<Partial<Record<CamId,boolean>>>({});

  const checkCameras = React.useCallback(async () => {
    const token = localStorage.getItem('pc_token') || '';
    const today = new Date().toISOString().slice(0,10);
    const yest  = new Date(Date.now()-86400000).toISOString().slice(0,10);
    const newSt: Partial<Record<CamId,CamStatus>> = {};
    for (const cam of CAMERAS) {
      try {
        const [rT,rY] = await Promise.all([
          fetch(`/api/counts/hourly?store_id=${cam.id}&date=${today}`,{headers:{Authorization:'Bearer '+token}}),
          fetch(`/api/counts/hourly?store_id=${cam.id}&date=${yest}`, {headers:{Authorization:'Bearer '+token}})
        ]);
        const [dT,dY] = await Promise.all([rT.json(),rY.json()]);
        const hasT = Array.isArray(dT) && dT.some((h:any)=>(h.count||0)>0);
        const hasY = Array.isArray(dY) && dY.some((h:any)=>(h.count||0)>0);
        newSt[cam.id] = hasT ? 'online' : hasY ? 'sin-datos' : 'offline';
      } catch { newSt[cam.id]='offline'; }
    }
    setStatuses(newSt);
    setLastCheck(new Date().toLocaleTimeString('es-AR'));
    for (const cam of CAMERAS) {
      const st = newSt[cam.id];
      if ((st==='offline'||st==='sin-datos') && !alertSent.current[cam.id]) {
        alertSent.current[cam.id]=true;
        const label = st==='offline' ? 'OFFLINE' : 'SIN DATOS HOY';
        const msg = `ALERTA: Camara ${cam.branch} ${cam.name} (ID ${cam.id}) esta ${label}. Verificar conexion.`;
        fetch('/api/whatsapp/test',{
          method:'POST',
          headers:{'Content-Type':'application/json',Authorization:'Bearer '+token},
          body:JSON.stringify({message:msg})
        });
      }
      if (newSt[cam.id]==='online') alertSent.current[cam.id]=false;
    }
  },[]);

  React.useEffect(()=>{
    checkCameras();
    const iv=setInterval(checkCameras,60000);
    return ()=>clearInterval(iv);
  },[checkCameras]);

  const branches=Array.from(new Set(CAMERAS.map(c=>c.branch)));
  const online  =Object.values(statuses).filter(s=>s==='online').length;
  const sinDatos=Object.values(statuses).filter(s=>s==='sin-datos').length;
  const offline =Object.values(statuses).filter(s=>s==='offline').length;

  return (
    <div style={{padding:'24px',fontFamily:'inherit'}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'20px'}}>
        <h2 style={{margin:0,fontSize:'22px',fontWeight:700}}>Monitor de Camaras</h2>
        <div style={{display:'flex',gap:'16px',fontSize:'14px'}}>
          <span style={{color:'#22c55e',fontWeight:600}}>{online} Online</span>
          <span style={{color:'#f59e0b',fontWeight:600}}>{sinDatos} Sin datos</span>
          <span style={{color:'#ef4444',fontWeight:600}}>{offline} Offline</span>
          {lastCheck && <span style={{color:'#666'}}>Act: {lastCheck}</span>}
        </div>
      </div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(260px,1fr))',gap:'16px'}}>
        {branches.map(branch=>(
          <div key={branch} style={{background:'#fff',border:'1px solid #e5e7eb',borderRadius:'12px',padding:'16px',boxShadow:'0 1px 4px rgba(0,0,0,0.06)'}}>
            <h3 style={{margin:'0 0 12px',fontSize:'16px',fontWeight:700,color:'#1e293b',borderBottom:'2px solid #f1f5f9',paddingBottom:'8px'}}>{branch}</h3>
            {CAMERAS.filter(c=>c.branch===branch).map(cam=>{
              const st=statuses[cam.id]||'loading';
              const color=st==='online'?'#22c55e':st==='sin-datos'?'#f59e0b':st==='offline'?'#ef4444':'#9ca3af';
              const label=st==='online'?'ONLINE':st==='sin-datos'?'SIN DATOS':st==='offline'?'OFFLINE':'...';
              return (
                <div key={cam.id} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'8px 0',borderBottom:'1px solid #f8fafc'}}>
                  <span style={{fontSize:'14px',color:'#374151'}}>{cam.name} <span style={{color:'#9ca3af',fontSize:'12px'}}>(ID {cam.id})</span> <span style={{fontSize:'11px',fontWeight:600,color:cam.tipo==='IMOU'?'#6366f1':'#0891b2',background:cam.tipo==='IMOU'?'#ede9fe':'#cffafe',padding:'1px 6px',borderRadius:'8px'}}>{cam.tipo}</span></span>
                  <span style={{fontSize:'12px',fontWeight:700,color:color,background:color+'18',padding:'2px 10px',borderRadius:'12px'}}>{label}</span>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}

function App() {
  const [token, setToken]     = useState(localStorage.getItem('pc_token') || '');
  const [navTab, setNavTab]   = useState<'dashboard' | 'users' | 'whatsapp' | 'feriados' | 'horarios' | 'analytics' | 'vision' | 'monthly-goals' | 'seller-goals' | 'cameras'>('dashboard');
  const [dashDate, setDashDate] = React.useState<string>(TODAY);
  const isToday = dashDate === TODAY;
  const goBack = () => { const d = new Date(dashDate + 'T12:00:00'); d.setDate(d.getDate()-1); setDashDate(d.toISOString().slice(0,10)); };
  const goFwd  = () => { if (!isToday) { const d = new Date(dashDate + 'T12:00:00'); d.setDate(d.getDate()+1); setDashDate(d.toISOString().slice(0,10)); } };
  const getUserRole = () => { try { const t = localStorage.getItem("pc_token"); if (!t) return "viewer"; const p = JSON.parse(atob(t.split(".")[1])); return p.role || "viewer"; } catch(e) { return "viewer"; } };
  const getUserStoreIds = () => { try { const t = localStorage.getItem("pc_token"); if (!t) return null; const p = JSON.parse(atob(t.split(".")[1])); return p.store_ids || null; } catch(e) { return null; } };
  const getUserName = () => { try { const t = localStorage.getItem("pc_token"); if (!t) return ""; const p = JSON.parse(atob(t.split(".")[1])); return p.sub || ""; } catch(e) { return ""; } };
  const userRole = getUserRole();
  const userStoreIds = getUserStoreIds();
  const userName = getUserName();
  const [storeTab, setStoreTab] = useState(1);
  const [sideOpen, setSideOpen] = useState(true);

  if (!token) return <LoginPage onLogin={setToken} />;

  const allowedStores = userStoreIds ? STORES.filter(s => userStoreIds.split(',').map(Number).includes(s.id)) : STORES;
  const currentStore = allowedStores.find(s => s.id === storeTab) || allowedStores[0] || STORES[0];

  return (
    <div className="app-layout">
      <nav className={`sidebar ${sideOpen ? '' : 'sidebar-closed'}`}>
        <div className='sidebar-logo'><img src='/logo512.png' alt='veo360' style={{width:'85%',objectFit:'contain',display:'block',margin:'0 auto'}} /></div>
        <div className={`nav-item ${navTab === 'dashboard' ? 'active' : ''}`} onClick={() => setNavTab('dashboard')}>
          <span className="nav-icon">▦</span>{sideOpen && <span>Dashboard</span>}
        </div>
            {userRole === 'admin' && <div className={`nav-item ${navTab === 'users' ? 'active' : ''}`} onClick={() => setNavTab('users')}><span className="nav-icon">👤</span>{sideOpen && <span>Usuarios</span>}</div>}
            {(userRole === 'admin' || userRole === 'editor') && <div className={'nav-item ' + (navTab === 'whatsapp' ? 'active' : '')} onClick={() => setNavTab('whatsapp')}><span className="nav-icon">💬</span>{sideOpen && <span>WhatsApp</span>}</div>}
        {(userRole === 'admin' || userRole === 'editor') && <div className={'nav-item' + (navTab === 'feriados' ? ' active' : '')} onClick={() => setNavTab('feriados')}><span className="nav-icon">📅</span><span>Feriados</span></div>}
            {(userRole === 'admin' || userRole === 'editor') && <div className={'nav-item' + (navTab === 'horarios' ? ' active' : '')} onClick={() => setNavTab('horarios')}><span className="nav-icon">🕐</span><span>Horarios</span></div>}
            <div className={'nav-item' + (navTab === 'analytics' ? ' active' : '')} onClick={() => setNavTab('analytics')}><span className="nav-icon">📊</span><span>Analytics</span></div>
            <div className={'nav-item' + (navTab === 'vision' ? ' active' : '')} onClick={() => setNavTab('vision')}><span className="nav-icon">&#128065;</span>{sideOpen && <span>Vision IA</span>}</div>
        {(userRole === 'admin' || userRole === 'editor') && <div className={`nav-item ${navTab === 'monthly-goals' ? ' active' : ''}`}
          onClick={() => setNavTab('monthly-goals')}
        >
          <span className="nav-icon">🎯</span>{sideOpen && <span>Obj. Mensuales</span>}
        </div>}
        {(userRole === 'admin' || userRole === 'editor') && <div className={`nav-item ${navTab === 'seller-goals' ? ' active' : ''}`}
          onClick={() => setNavTab('seller-goals')}
        >
          <span className="nav-icon">👥</span>{sideOpen && <span>Obj. Vendedores</span>}
        </div>}
        <div
          className={'nav-item' + (navTab === 'cameras' ? ' active' : '')}
          onClick={() => setNavTab('cameras')}
        >
          <span className="nav-icon">&#128247;</span>
          {sideOpen && <span>Camaras</span>}
        </div>
        <div className="sidebar-bottom">
          <div className="nav-user">{sideOpen && <span>{userName}</span>}</div>
          <div className="nav-item" onClick={() => { localStorage.removeItem('pc_token'); setToken(''); }}>
            <span className="nav-icon">⏻</span>{sideOpen && <span>Salir</span>}
          </div>
        </div>
      </nav>

      <main className="main-content">
        <button className="menu-btn" onClick={() => setSideOpen(!sideOpen)}>☰</button>

        {navTab === 'dashboard' && (
          <>
            <div className="dashboard-header" style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
              <h1>Dashboard</h1>
              <div style={{display:'flex',alignItems:'center',gap:'6px'}}>
                <button onClick={goBack} style={{background:'rgba(255,255,255,0.1)',border:'1px solid rgba(255,255,255,0.2)',color:'#e2e8f0',borderRadius:'6px',width:'28px',height:'28px',cursor:'pointer',fontSize:'16px',display:'flex',alignItems:'center',justifyContent:'center',lineHeight:1}}>&#8249;</button>
                <div className="date-badge" style={{minWidth:'96px',textAlign:'center'}}>{dashDate}</div>
                <button onClick={goFwd} style={{background:isToday?'rgba(255,255,255,0.05)':'rgba(255,255,255,0.1)',border:'1px solid rgba(255,255,255,0.2)',color:isToday?'#475569':'#e2e8f0',borderRadius:'6px',width:'28px',height:'28px',cursor:isToday?'default':'pointer',fontSize:'16px',display:'flex',alignItems:'center',justifyContent:'center',lineHeight:1}}>&#8250;</button>
              </div>
            </div>

            {/* Tabs de sucursales */}
            <div className="store-tabs">
              {allowedStores.map(s => (
                <button key={s.id}
                  className={`store-tab-btn ${storeTab === s.id ? 'active' : ''}`}
                  onClick={() => setStoreTab(s.id)}>
                  {s.name}
                </button>
              ))}
            </div>

            <StorePanel key={storeTab} storeId={storeTab} storeName={currentStore.name} dashDate={dashDate} />
          </>
        )}

        {navTab === 'users' && userRole === 'admin' && <UsersPanel token={token} />}
        {navTab === 'whatsapp' && (userRole === 'admin' || userRole === 'editor') && <WhatsAppPanel token={token} />}
        {navTab === 'feriados' && (userRole === 'admin' || userRole === 'editor') && <FeriadosPanel token={token} />}
        {navTab === 'horarios' && (userRole === 'admin' || userRole === 'editor') && <HorariosPanel token={token} />}
        {navTab === 'analytics' && <AnalyticsPanel token={token} />}
        {navTab === 'vision' && <VisionPanel />}
      {navTab === 'monthly-goals' && <MonthlyGoalsWidget />}
      {navTab === 'seller-goals' && <SellerGoalsWidget />}
      {navTab === 'cameras' && <CameraMonitorWidget />}
        </main>
    </div>
  );
}


